/**
 * Onboarding event bus — tiny window-event helpers so app code can report
 * "the user actually did the thing" without importing onboarding internals.
 *
 * Step keys mirror the Welcome Checklist / tours (titles live in steps.jsx):
 *   find-the-fire, read-the-alert, move-the-numbers, add-your-people, import-your-org
 * ('barometer' was removed in Beta-1 — the Barometer moves to the HUGO assistant.)
 */
export const ONBOARDING_STEP_EVENT = 'repsit-onboarding-step';
export const TOUR_EVENT = 'repsit-tour';
export const OPEN_WELCOME_EVENT = 'repsit-open-welcome';

export const ONBOARDING_STEPS = [
  'find-the-fire',
  'read-the-alert',
  'move-the-numbers',
  'add-your-people',
  'import-your-org',
];

/** Report that the user genuinely completed an onboarding step's action. */
export function emitOnboardingStep(step) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ONBOARDING_STEP_EVENT, { detail: { step } }));
}

/** Internal: tour lifecycle events (started | completed | skipped). */
export function emitTourEvent(type, key, extra = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TOUR_EVENT, { detail: { type, key, ...extra } }));
}
